export default __webpack_public_path__ + "static/media/parallaxQuoteDark.f7a8e5c3.svg";